export class TextHighlightValueConverter {
  toView(value: string, highlight: string) {
    if (value == null) return null;
    if (highlight == null || highlight.length === 0) return [{ substring: value, highlight: false }];
    const expression = new RegExp(`(${highlight.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')})`, 'i');
    const splits = value.split(expression);
    const highlightLowerCase = highlight.toLowerCase();
    return splits.map(split => ({ substring: split, highlight: split.toLowerCase() === highlightLowerCase }));
  }
}
